<template>
  <NuxtLoadingIndicator color="#be4044" :height="5" />
  <MainMenu />
  <Error404 :error="{ statusCode: 404 }" v-if="error" />
  <BlockWhyWe />
  <BlockZakaz />
  <BlockAchievements />
  <BlockContact />
  <BlockFoot />
</template>

<script setup>
const props = defineProps(["error"]);
const { data } = await useFetch("/api/start");
provide("contacts", data?.value?.contacts);
//provide("formOptions", data?.value?.formOptions);
provide("social", data?.value?.social);
provide("yaMap", data?.value?.yaMap);
provide("achievements", data?.value?.achievements);
</script>
